"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOG_LEVELS = void 0;
const objectHelper_1 = require("./utils/objectHelper");
exports.LOG_LEVELS = {
    DEBUG: 'debug',
    INFO: 'info',
    WARN: 'warn',
    ERROR: 'error',
};
const logLevelDebug = [exports.LOG_LEVELS.DEBUG];
const logLevelInfo = [exports.LOG_LEVELS.DEBUG, exports.LOG_LEVELS.INFO];
const logLevelWarn = [exports.LOG_LEVELS.DEBUG, exports.LOG_LEVELS.INFO, exports.LOG_LEVELS.WARN];
const logLevelError = [
    exports.LOG_LEVELS.DEBUG,
    exports.LOG_LEVELS.INFO,
    exports.LOG_LEVELS.WARN,
    exports.LOG_LEVELS.ERROR,
];
const logStyles = `
  color: #fff;
  font-weight: bold;
  background: purple;
  padding:4px 6px;
  border-radius: 2px;
`;
class Logger {
    logEnabled;
    logLevel;
    constructor(logEnabled, logLevel) {
        this.logEnabled = logEnabled;
        this.logLevel = logLevel;
    }
    debug = (...args) => {
        if (this.logEnabled && logLevelDebug.includes(this.logLevel)) {
            // eslint-disable-next-line no-console
            console.debug('CueAnalytics: ', ...args);
        }
    };
    log = (...args) => {
        if (this.logEnabled && logLevelInfo.includes(this.logLevel)) {
            // eslint-disable-next-line no-console
            console.groupCollapsed(`%c${args[0]}`, logStyles);
            // eslint-disable-next-line no-console
            args[1] && console.table((0, objectHelper_1.getFlattenObject)(args[1]));
            // eslint-disable-next-line no-console
            console.groupEnd();
        }
    };
    warn = (...args) => {
        if (this.logEnabled && logLevelWarn.includes(this.logLevel)) {
            // eslint-disable-next-line no-console
            console.warn('CueAnalytics: ', ...args);
        }
    };
    error = (...args) => {
        if (this.logEnabled && logLevelError.includes(this.logLevel)) {
            // eslint-disable-next-line no-console
            console.error('CueAnalytics: ', ...args);
        }
    };
    enableLogs() {
        this.logEnabled = true;
    }
    disableLogs() {
        this.logEnabled = false;
    }
}
exports.default = Logger;
//# sourceMappingURL=logger.js.map